import {Component} from '@angular/core';
import {Field} from '../../model/field.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../state.service';

@Component({
    selector: 'app-add-field',
    templateUrl: './add-field.component.html',
    styleUrls: ['./add-field.component.css'],
    standalone: false
})
export class AddFieldComponent {
  field = new Field();
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {}

  onSubmit() {
    this.stateService.addField(this.field);
    this.submitted = true;
    this.router.navigate( ['field']);
  }

}
